module.exports = __webpack_public_path__ + "static/media/logo.5e8b7bef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/logo.svg
// module id = 2309
// module chunks = 0